import { Heart, Dna, Bone, Baby, Tooth } from "@phosphor-icons/react";
import { Reveal, SectionHeading } from "../Reveal";

const SPECIALTIES = [
    { icon: Heart, title: "Cardiology", text: "Advanced cardiac evaluation and treatment pathways." },
    { icon: Dna, title: "Oncology", text: "Cancer diagnosis, treatment planning and specialized oncology care." },
    { icon: Bone, title: "Orthopedics", text: "Joint replacement, spine, sports medicine and orthopedic procedures." },
    { icon: Baby, title: "Fertility & IVF", text: "Fertility assessment and assisted reproductive care." },
    { icon: Tooth, title: "Dental", text: "Implants, restorative dentistry and specialized dental care." },
];

export default function Specialties() {
    return (
        <section id="specialties" data-testid="specialties-section" className="py-28 lg:py-36 bg-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <SectionHeading
                    chapter="07"
                    eyebrow="Specialties"
                    title="Starting where India has a global advantage."
                    testid="specialties-heading"
                />
                <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
                    {SPECIALTIES.map((s, i) => (
                        <Reveal key={s.title} delay={0.07 * i}>
                            <div
                                data-testid={`specialty-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                                className="group h-full rounded-3xl border border-slate-100 bg-white p-8 text-left shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:-translate-y-1.5 hover:border-brand-green/30 hover:shadow-[0_24px_48px_rgb(13,148,136,0.12)] transition-[transform,box-shadow,border-color] duration-300"
                            >
                                <div className="w-12 h-12 rounded-full bg-tint-green flex items-center justify-center text-brand-green group-hover:bg-brand-green group-hover:text-white transition-colors duration-300">
                                    <s.icon size={24} weight="duotone" />
                                </div>
                                <h3 className="mt-6 font-heading text-lg font-semibold text-brand-blue">{s.title}</h3>
                                <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.35}>
                    <p data-testid="specialties-footer-note" className="mt-12 text-sm text-slate-500 max-w-2xl">
                        Our specialty network will expand based on patient demand, clinical expertise and healthcare-provider partnerships.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
